"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var react_text_mask_1 = __importDefault(require("react-text-mask"));

var styled_components_1 = __importDefault(require("styled-components"));

var createAutoCorrectedDatePipe_1 = __importDefault(require("text-mask-addons/dist/createAutoCorrectedDatePipe"));

var defaultDateFormat = 'mm/dd/yyyy';
var defaultPlaceholder = '__/__/____';
var defaultMinYear = 1900;

var MaskedInputDateWeb =
/** @class */
function (_super) {
  __extends(MaskedInputDateWeb, _super);

  function MaskedInputDateWeb(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      value: ''
    };

    _this.onChangeHandler = function (event) {
      var value = event.target.value;

      _this.props.onChange(value);
    };

    _this.onEnterKeyPressHandler = function (event) {
      var key = event.key;
      var onEnterKeyPress = _this.props.onEnterKeyPress;
      var enterKey = 'Enter';

      if (key === enterKey && onEnterKeyPress) {
        onEnterKeyPress(event);
      }
    };

    _this.renderCustomComponent = function (boundVal, props) {
      var _a = _this.props,
          name = _a.field.name,
          _b = _a.form,
          errors = _b.errors,
          touched = _b.touched,
          values = _b.values,
          isSubmitting = _b.isSubmitting;
      return react_1.default.createElement(components_lib_1.RowWrapper, null, react_1.default.createElement(exports.StyledTextInput, __assign({
        ref: function ref(input) {
          return boundVal(input);
        },
        isFilled: touched[name] && values[name],
        isError: touched[name] && errors[name],
        isDisabled: isSubmitting
      }, props)), react_1.default.createElement(components_lib_1.ValidationIconWrapper, null, touched[name] ? react_1.default.createElement(components_lib_1.ValidationIcon, {
        isValid: !(touched[name] && errors[name])
      }) : null));
    }; /// the date format should be in small caps


    var minYear = props.minYear;

    var dateFormat = _this.getDateFormat();

    _this.autoCorrectedDatePipe = createAutoCorrectedDatePipe_1.default(dateFormat, {
      minYear: minYear ? minYear : defaultMinYear,
      maxYear: utilities_1.getCurrentYear()
    });
    return _this;
  }

  MaskedInputDateWeb.prototype.getDateFormat = function () {
    var dateFormat = this.props.dateFormat;
    if (!dateFormat) return defaultDateFormat;
    return dateFormat.toLowerCase();
  };

  MaskedInputDateWeb.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        placeholder = _a.placeholder;
    var keyPressHandler = react_native_1.Platform.select({
      web: this.onEnterKeyPressHandler
    });
    return react_1.default.createElement(react_text_mask_1.default, {
      value: value,
      keepCharPositions: true,
      guide: true,
      placeholder: placeholder ? placeholder : defaultPlaceholder,
      mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      pipe: this.autoCorrectedDatePipe,
      onChange: this.onChangeHandler,
      onKeyPress: keyPressHandler,
      render: this.renderCustomComponent,
      onKeyDown: this.props.onKeyDown
    });
  };

  return MaskedInputDateWeb;
}(react_1.PureComponent);

exports.MaskedInputDateWeb = MaskedInputDateWeb;
exports.StyledTextInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (props) {
  return components_lib_1.styledTextInputStyles(props);
});
var templateObject_1;